export default "__VITE_ASSET__4ec7c12c__"